import { apiClient } from './apiClient'

export interface DoubtResponse {
  id?: string
  Id?: string
  question?: string
  Question?: string
  answer?: string
  Answer?: string
  imageUrl?: string
  ImageUrl?: string
  videoUrl?: string
  VideoUrl?: string
  externalVideoLink?: string
  ExternalVideoLink?: string
  order?: number
  Order?: number
  isActive?: boolean
  IsActive?: boolean
  createdAt?: string
  CreatedAt?: string
  updatedAt?: string
  UpdatedAt?: string
}

const doubtResponseApiService = {
  async getActiveDoubtResponses(): Promise<DoubtResponse[]> {
    const response = await apiClient.get<DoubtResponse[]>('/doubt-responses')
    return response.data
  },

  async getDoubtResponseById(id: string): Promise<DoubtResponse> {
    const response = await apiClient.get<DoubtResponse>(`/doubt-responses/${id}`)
    return response.data
  },
}

export default doubtResponseApiService

